import { LoginResult } from '@api/login';
import { PathChecker, RoutePathsApp } from '@modules/router';

function isValidApplicationHash() {
    return (
        window.location.hash &&
        window.location.hash !== '#' &&
        PathChecker.isMatch(window.location.hash.substring(1), RoutePathsApp)
    );
}

export default function loginResponseHandler(loginResult: number): boolean {
    if (loginResult === LoginResult.SUCCESS) {
        if (isValidApplicationHash()) {
            window.location.href = '/app/' + window.location.hash;
            return true;
        }

        window.location.href = '/operations/projects/eps.aspx';
        return true;
    }

    if (loginResult === LoginResult.ACCOUNT_EXPIRED) {
        window.location.href = '/operations/my-account/pg-my-account.aspx';
        return true;
    }

    if (loginResult === LoginResult.PROGRESS_REQUEST_REDIRECT) {
        const urlParams = new URLSearchParams(window.location.search);
        const period = urlParams.get('period') || '';
        window.location.href = '/operations/progress-requests/pg-progress-requests.aspx?period=' + period;
        return true;
    }

    if (loginResult === LoginResult.ACCOUNT_NOT_ACTIVATED) {
        window.location.hash = '#account-activation-required';
        return true;
    }

    return false;
}
